import { render, staticRenderFns } from "./AtcPriceDisplay.vue?vue&type=template&id=a3271fe4&scoped=true&"
import script from "./AtcPriceDisplay.vue?vue&type=script&lang=js&"
export * from "./AtcPriceDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3271fe4",
  null
  
)

export default component.exports